var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5842 2.52702C16.3946 1.8131 15.836 1.25075 15.1265 1.05993C13.8408 0.713135 8.68506 0.713135 8.68506 0.713135C8.68506 0.713135 3.52931 0.713135 2.24349 1.05993C1.53416 1.25075 0.975464 1.8131 0.78586 2.52702C0.441406 3.82118 0.441406 6.52116 0.441406 6.52116C0.441406 6.52116 0.441406 9.22124 0.78586 10.5154C0.975464 11.2293 1.53416 11.7916 2.24349 11.9825C3.52931 12.3292 8.68506 12.3292 8.68506 12.3292C8.68506 12.3292 13.8408 12.3292 15.1265 11.9825C15.836 11.7916 16.3946 11.2293 16.5842 10.5154C16.9287 9.22124 16.9287 6.52116 16.9287 6.52116C16.9287 6.52116 16.9287 3.82118 16.5842 2.52702Z",
    fill: "#ED1F24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9978 8.97264L11.307 6.52128L6.9978 4.06982V8.97264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e320c8a9701ac729fee6aeb5ed4dd036.svg";
export { ForwardRef as ReactComponent };